import Router from 'next/router';
import replaceParams from '../../util/replaceParams';
import replaceUrl from '../../util/replaceUrl.web';

const push = ({ url }, params) => {
    Router.push(replaceUrl(url), replaceParams(url, params));
};

export default push;
